/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-useless-computed-key */
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Field, FieldArray, Form, Formik } from "formik";
import Switch from 'react-switch';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import Colors from 'constants/Colors';
import MasksHelper from 'utils/src/masks';
import Layout from 'components/Layout';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import { Col, Row } from 'components/Grid';
import { Label, GridColumnTitle, CheckBox } from "components/Form";
import InputField from 'components/Form/InputField';
import DialogComponent from "components/Dialog";
import { LostCancelButton } from 'components/index';
import Loader from 'components/Loader';
import HasPermission from 'components/HasPermission';
import Icon from "components/Icon";
import SearchField from 'components/Form/SearchField';
import {
  BorderSwitch,
  ButtonContent,
  DialogCancel,
  DialogConfirm,
  Line,
  PlaceHolder,
  Scrollbox,
  TagInput,
  Text,
  NewButton,
  TableHeader,
  TableCollum,
  InlineLabel,
  TableHead,
  TableRow,
  TableBody,
  Table,
  RowLockAndSave,
  Title,
  LabelEdit,
  AddButton,
  TotalValueContainer,
  TotalContainer,
  HrTotal
} from './styles';
import ComboBox from 'components/Form/ComboBox3';
import IMask from 'imask';
import RenderButtons from 'components/RenderButtons';
import ModalContacts from 'components/ModalContacts/index';
import ValidationError from 'components/Form/ValidationError';
import { FormSection } from '@fitinsur/components';
import {
  useInsurerValues, useListStampsContacts, useHeaderNbi, useScheduleStatus, useInsurerLock,
  useImportStatus, useCreateMarketChangeQuotation, useUpdateNBIManually, useEndorsementDoc, useSaveInsurerTaxes, useInsurerTaxes
} from 'services/QuoteService';
import { useGetOperationAsync, useOperationInfo } from 'services/OperationService';
import {
  useGetQuestionnaireAnswer,
  useDeleteQuestionnaireAnswer,
  useSaveQuestionnaireAnswer,
  useGetQuestionnairesByIdProduct
} from 'services/QuestionnaireAnswerService';
import { camelCase, isObject, uniqueId } from 'lodash';
import { usePersonList } from 'services/PersonService';
import { groupMultipleFieldQuestions, handleQuestionsInitialAdjustments, handleRequestSerproCnpj, removeAnswersDuplicateSession, handleQuestionChange } from './handleQuestionChange';

export default function MarketComposition(props) {
  const maskHelper = new MasksHelper();

  const [maxValuePerc, setMaxValuePerc] = useState(100);
  const [isMAS, setIsMAS] = useState(false);
  const [isNewYork, setIsNewYork] = useState(false);
  const [json, updateContext] = useState({});
  const [questions, setQuestions] = useState([]);
  var maskPercentage = {
    mask: Number,
    scale: 5,  // digits after point, 0 for integers
    signed: true,  // disallow negative
    thousandsSeparator: ',',  // any single char
    padFractionalZeros: true,  // if true, then pads zeros at end to the length of scale
    normalizeZeros: false,  // appends or removes zeros at ends
    radix: '.',  // fractional delimiter
    min: 0,
  };

  const [isExported, setExported] = useState(false);
  const [isImported, setImported] = useState(false);
  const [retry, setRetry] = useState(0);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [quotationOperationId, setQuotationOperationId] = useState(null);
  const [summary, setSummary] = useState({});
  const [data, setData] = useState([]);
  const [maxLimit, setMaxLimit] = useState(null);
  const [masks, setMasks] = useState([]);
  const [isBound, setIsBound] = useState(false);
  const [operation, setOperation] = useState(null);
  const [validation, setValidation] = useState(yup.object().shape({}));
  const [sortBy, setSortBy] = useState({
    key: null,
    direction: null,
  });

  const [confirmed, setConfirmed] = useState({
    visible: false,
    title: "",
    icon: "times-circle",
    args: null,
  });
  const [facilities, setFacilities] = useState([]);
  const [updateNBIManually, setUpdateNBIManually] = useState(false);
  const [modalUnderwriter, setModalUnderwriter] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [insurerContacts, setInsurerContacts] = useState(false);
  const [selectedUnderwriters, setSelectedUnderwriters] = useState([]);
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const isClient = useMemo(() => authContext.enumProfile === 1 || props?.location?.state?.disabled, []);
  const [isUpdatedSchedule, setIsUpdatedSchedule] = useState(props?.path?.includes('market-composition-updated-schedule'));
  const [idOperationRedirect, setIdOperationRedirect] = useState(null);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [obligorGroup, setObligorGroup] = useState([]);
  const [insurerGroup, setInsurerGroup] = useState([]);
  const [insurersTaxes, setInsurersTaxes] = useState([]);
  const [idProduct, setIdProduct] = useState(null);
  const [canGroup, setCanGroup] = useState(false);
  const [isGrouped, setIsGrouped] = useState(false);
  const [lockAndSaveCoverages, setLockAndSaveCoverages] = useState(false);
  const [loadingTimeout, setLoadingTimeout] = useState(false);

  const history = useHistory();
  const formik = useRef(Formik);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useInsurerValuesData,
    loading: useInsurerValuesLoading,
    error: useInsurerValuesError,
    status: useInsurerValuesStatus,
    request: useInsurerValuesRequest,
  } = useInsurerValues(props.match.params.idOperation);

  const {
    data: useInsurerTaxesData,
    loading: useInsurerTaxesLoading,
    error: useInsurerTaxesError,
    status: useInsurerTaxesStatus,
    request: useInsurerTaxesRequest,
  } = useInsurerTaxes(props.match.params.idOperation);

  const {
    data: useSaveInsurerTaxesData,
    loading: useSaveInsurerTaxesLoading,
    error: useSaveInsurerTaxesError,
    status: useSaveInsurerTaxesStatus,
    request: useSaveInsurerTaxesRequest,
  } = useSaveInsurerTaxes(props.match.params.idOperation);

  const {
    data: useListStampsContactsData,
    loading: useListStampsContactsLoading,
    error: useListStampsContactsError,
    status: useListStampsContactsStatus,
    request: useListStampsContactsRequest,
  } = useListStampsContacts(props.match.params.idOperation);

  const {
    data: useScheduleStatusData,
    loading: useScheduleStatusLoading,
    error: useScheduleStatusError,
    status: useScheduleStatusStatus,
    request: useScheduleStatusRequest,
  } = useScheduleStatus(props.match.params.idOperation);

  const {
    data: useInsurerLockData,
    loading: useInsurerLockLoading,
    error: useInsurerLockError,
    status: useInsurerLockStatus,
    request: useInsurerLockRequest,
  } = useInsurerLock();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useImportStatusData,
    loading: useImportStatusLoading,
    error: useImportStatusError,
    status: useImportStatusStatus,
    request: useImportStatusRequest,
  } = useImportStatus(props.match.params.idOperation);

  const {
    data: useCreateMarketChangeQuotationData,
    loading: useCreateMarketChangeQuotationLoading,
    error: useCreateMarketChangeQuotationError,
    status: useCreateMarketChangeQuotationStatus,
    request: useCreateMarketChangeQuotationRequest,
  } = useCreateMarketChangeQuotation();

  const {
    data: useUpdateNBIManuallyData,
    loading: useUpdateNBIManuallyLoading,
    error: useUpdateNBIManuallyError,
    status: useUpdateNBIManuallyStatus,
    request: useUpdateNBIManuallyRequest,
  } = useUpdateNBIManually();

  const {
    data: useEndorsementDocData,
    loading: useEndorsementDocLoading,
    error: useEndorsementDocError,
    status: useEndorsementDocStatus,
    request: useEndorsementDocRequest,
  } = useEndorsementDoc(props.match.params.idOperation, endorsmentType);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useGetOperationLoading,
    request: useGetOperationRequest
  } = useGetOperationAsync(props.match.params.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

  const {
    status: useDeleteQuestionnaireAnswerStatus,
    loading: useDeleteQuestionnaireAnswerLoading,
    request: useDeleteQuestionnaireAnswerRequest,
  } = useDeleteQuestionnaireAnswer(props.match.params.idOperation);

  const questionnaireSent = useRef(false);

  useEffect(() => {
    if (
      useInsurerValuesLoading ||
      useListStampsContactsLoading ||
      useHeaderNbiLoading ||
      useScheduleStatusLoading ||
      useInsurerLockLoading ||
      useOperationInfoLoading ||
      useImportStatusLoading ||
      useCreateMarketChangeQuotationLoading ||
      useUpdateNBIManuallyLoading ||
      useEndorsementDocLoading ||
      useInsurerTaxesLoading ||
      useSaveInsurerTaxesLoading ||
      useGetQuestionnairesAnswersLoading ||
      useGetOperationLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useDeleteQuestionnaireAnswerLoading ||
      loadingTimeout
    ) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [
    useInsurerValuesLoading,
    useListStampsContactsLoading,
    useHeaderNbiLoading,
    useScheduleStatusLoading,
    useInsurerLockLoading,
    useOperationInfoLoading,
    useImportStatusLoading,
    useCreateMarketChangeQuotationLoading,
    useUpdateNBIManuallyLoading,
    useEndorsementDocLoading,
    useInsurerTaxesLoading,
    useGetQuestionnairesAnswersLoading,
    useGetOperationLoading,
    useSaveQuestionnaireAnswerLoading,
    useDeleteQuestionnaireAnswerLoading,
    useSaveInsurerTaxesLoading,
    loadingTimeout
  ]);


  const coluns = [
    {
      title: "Insurer",
      value: "nmInsurer"
    },
    {
      title: "Legal Entity",
      value: "legalEntity"
    },
    {
      title: "Max Line Size",
      value: "maxLineSize"
    },
    {
      title: "Premium Rate",
      value: "premiumRate"
    },
    {
      title: "Line Size",
      value: "lineSize"
    },

    {
      title: "Line Size %",
      value: "percLineSize"
    },
    {
      title: "Brokerage",
      value: "brokerage"
    },
    {
      title: ''
    }
  ];

  const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]);


  var mask = {
    mask: Number,
    scale: 2,  // digits after point, 0 for integers
    signed: true,  // disallow negative
    thousandsSeparator: ',',  // any single char
    padFractionalZeros: true,  // if true, then pads zeros at end to the length of scale
    normalizeZeros: false,  // appends or removes zeros at ends
    radix: '.',  // fractional delimiter
    min: 0,
  };

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200 && insurersTaxes.length >= 1) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus, useOperationInfoStatus, insurersTaxes, operation]);

  useEffect(() => {
    if (useDeleteQuestionnaireAnswerStatus === 200) {
      useGetQuestionnairesAnswersRequest();
    }
  }, [useDeleteQuestionnaireAnswerStatus]);


  const endorsmentTypeEnum = {
    ['not-pre-agreed']: {
      title: 'Anniversary - Premium: Not Pre Agreed / MARKET COMPOSITION'
    },
    ['cancellation']: {
      title: 'Endorsement - Cancellation / MARKET COMPOSITION'
    },
    ['declaration']: {
      title: 'Endorsement - Declaration / MARKET COMPOSITION'
    },
    ['market-changes']: {
      title: 'Risk & Market Changes / MARKET COMPOSITION'
    }
  }

  function getGridItems() {
    useInsurerValuesRequest().then(({ data: res }) => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      let d = res.ret_value.facilities.map((facility) => {
        const insurers = facility.insurers.map((item) => {
          let insurer = {
            idPersonInsurer: item.idPersonInsurer,
            nmInsurer: item.nmInsurer,
            maxLineSize: item.nbiRequestInsurerResponse.maxLineSize,
            premiumRate: item.premiumRate != null ? item.premiumRate : item.nbiRequestInsurerResponse.premiumRate,
            lineSize: (!isNaN(Number(item.lineSize)) ? item.lineSize : item.nbiRequestInsurerResponse.lineSize),
            percLineSize: item.percLineSize != null ? item.percLineSize : item.nbiRequestInsurerResponse.percLineSize,
            brokerage: item.brokerage != null ? item.brokerage : item.nbiRequestInsurerResponse.brokerage,
            personInsurerLegalEntity: item.personInsurerLegalEntity,
            nbiRequestInsurerResponse: item.nbiRequestInsurerResponse
          };
          return insurer;
        }).sort((a, b) => String(a?.nmInsurer).localeCompare(String(b?.nmInsurer)))

        facility.insurers = insurers;
        return facility;
      });

      setQuotationOperationId(res.ret_value.quotationOperationId);
      setData(d);

      if ('bolSaveLineSize' in res.ret_value) {
        if (formik.current) {
          formik.current?.setFieldValue('lock', res.ret_value.bolSaveLineSize)
        }
      }
    })
  };

  function getInsurersTaxes() {
    useInsurerTaxesRequest().then(({ data: res }) => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      let d = res.ret_value.facilities.map((facility) => {
        const insurers = facility.insurers.sort((a, b) => String(a?.nmInsurer).localeCompare(String(b?.nmInsurer)))
        facility.insurers = insurers;
        return facility;
      });

      let canGroupTaxes = true;
      let taxesToGroup = {};

      ['clientTaxes', 'insurerTaxes'].map(key => {
        if (canGroupTaxes) {
          taxesToGroup[`${key}Qtd`] = [];
          taxesToGroup[`everyTaxesFrom${key}`] = [];
          d.map(fac => fac.insurers.map(insurer => {
            if (taxesToGroup[`everyTaxesFrom${key}`].length == 0 && insurer[key]?.length) {
              taxesToGroup[`everyTaxesFrom${key}`].push(...insurer[key]);
            } else if (insurer[key]?.length) {
              insurer[key].map((taxClient) => {
                let alreadyExistsTaxes = taxesToGroup[`everyTaxesFrom${key}`].find(tax => tax.feeType == taxClient.feeType && tax.feeValue == taxClient.feeValue);
                if (!alreadyExistsTaxes) {
                  canGroupTaxes = false;
                }
              })
            }
            taxesToGroup[`${key}Qtd`].push(insurer[key]?.length ? insurer[key].length : 0)
          }))

          canGroupTaxes = canGroupTaxes ? [...new Set(taxesToGroup[`${key}Qtd`])].length == 1 : false;
        }
      });

      setTimeout(() => {
        setCanGroup(canGroupTaxes);
        setInsurersTaxes(d);
      }, 300);
    })
  }

  const getMasks = async () => {
    const t = await maskHelper.getMaskConfigs([69, 70], 295, authContext.token);
    setMasks(t);
  };

  function listContacts() {
    useListStampsContactsRequest(null, { forcePersonRolesContacts: true }).then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      setContacts(data.ret_value.contacts);
    }).catch((error) => {
      mc.error("There was an error while fetching your data:  \n" + error);
      console.error('fitPostListContact - Error:', error);
    });
  };

  function handleSummary() {
    useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        obligorCoding: data.ret_value.obligorCoding,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        currency: data.ret_value.currency,
        nmObligor: data.ret_value.nmObligor,
        idOperation: props.match.params.idOperation,
      });

      setEndorsmentType(data.ret_value.endorsmentType);
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
      console.error('fitPostSummary - Error:', error);
    });
  };

  const getScheduleStatus = async () => {
    useScheduleStatusRequest().then(({ data }) => {
      switch (data.ret_value.render.showButton) {
        case 'IMPORT SCHEDULE':
          setExported(true);
          break;
        case 'EXPORT SCHEDULE':
          setExported(false);
          break;
        case 'GENERATE WORDING':
          setExported(true);
          setImported(true);
          break;
        case 'CONFIRM SCHEDULE':
          setExported(true);
          break;
        default:
          setExported(false);
          break;
      }
    })
      .catch((error) => {
        mc.error("Erro executando consulta do status\n" + error);
      })
  };

  const handleUpload = async (event, formikProps) => {
    loading.start();
    if (!event.target.files[0]) {
      mc.error('Invalid file, please select a valid one');
      loading.stop();
      return
    };

    let file = event.target.files[0];

    handleImport(file);

    event.target.value = null;
  };

  const handleImport = (file) => {
    const formData = new FormData();
    formData.append('fileDocument', file)
    formData.append('idOperation', props.match.params.idOperation)
    formData.append('isUpdatedSchedule', isUpdatedSchedule)

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestImportExcel(formData).then(x => x.json()).then(res => {
      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        loading.stop();
        return;
      }

      setIdOperationRedirect(res.ret_value.idOperationUpdatedSchedule);
      setRetry(1);
    }).catch(err => {
      mc.error("An error happened, please try again");
      loading.stop();
    })
  };

  function testJSON(text) {
    if (typeof text !== "string") {
      return false;
    }
    try {
      JSON.parse(text);
      return true;
    }
    catch (error) {
      return false;
    }
  };

  const handleQuestionnaire = async (data) => {
    let questionnaire = [];
    questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc,
    ];
    if (questionnaire && questionnaire.length > 0) {
      let isMasNy = !isMAS && !isNewYork;
      questionnaire = handleQuestionsInitialAdjustments(questionnaire, null, operation, isMasNy);
      questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

      const lockCoveragesAndTaxes = questionnaire.find(question => question.idQuestion === 1515);

      //if (formik.current) formik.current?.setFieldValue(lockCoveragesAndTaxes.key, lockCoveragesAndTaxes?.answer || "No");
      setLockAndSaveCoverages(lockCoveragesAndTaxes?.idAnswerOption === 7095)


      const initialCacheTaxes = questionnaire.filter(q => q.idQuestion == 1378 && !q.answer && q.idQuestionnaireAnswers);
      setObligorGroup(groupMultipleFieldQuestions(759, JSON.parse(JSON.stringify(questionnaire)), operation, isBound, isMasNy))
      buildValidation(JSON.parse(JSON.stringify(questionnaire)))
      buildValidation(JSON.parse(JSON.stringify(questionnaire)))

      let forAllUnderwritersAndFacilities = questionnaire.find(q => q.idQuestion == 1377);
      let existsInsurersAnswers = questionnaire.find(q => q.idQuestion == 1378 && q?.answer)?.answer;

      let insurers = groupMultipleFieldQuestions(1378, questionnaire, null, isBound, insurersTaxes.length == 0);

      let isGrouped = forAllUnderwritersAndFacilities?.idAnswerOption == 6809;
      setIsGrouped(isGrouped);

      if (!existsInsurersAnswers && insurersTaxes.length) {
        handleTaxes(forAllUnderwritersAndFacilities, insurers, null, questionnaire);
        if (initialCacheTaxes?.length) {
          setQuestionnaireAnswersToDelete([
            ...questionnaireAnswersToDelete,
            ...initialCacheTaxes.map(q => q.idQuestionnaireAnswers),
          ]);
        }
      } else {
        setCanGroup(isGrouped || canGroup);
        insurers.map(taxRow => {
          taxRow = handleQuestionsInitialAdjustments(taxRow, null, operation);
        })
        setInsurerGroup(JSON.parse(JSON.stringify(insurers || [])));
      }
      setQuestionnaire(JSON.parse(JSON.stringify(questionnaire)));
    }
  }

  const handleTaxes = (answerTax, insurersAll, handleSwitch = false, questionnaireAnswers = []) => {
    let qtdTaxes;
    let taxes = [];
    let allTaxes = {};
    let isGrouped = answerTax?.idAnswerOption == 6809 || !answerTax?.idAnswerOption;
    let taxesToGroup = {};
    let areTaxesLevelUpdate;

    if (handleSwitch) {
      let arrayToDelete = [];
      insurerGroup.map(q => arrayToDelete = [...arrayToDelete, ...q.map(question => question.idQuestionnaireAnswers)].filter(idQuestionnaireAnswers => idQuestionnaireAnswers))

      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...arrayToDelete
      ])
    }

    try {
      if (insurersTaxes.length) {
        if (isGrouped && canGroup) {
          for (const fac of insurersTaxes) {
            for (const key of ['clientTaxes', 'insurerTaxes']) {
              allTaxes[`arrayFrom${key}`] = fac?.insurers?.find(i => i[key]?.length >= 1) ? fac?.insurers?.find(i => i[key]?.length >= 1)[key] : [];

              if (allTaxes[`arrayFrom${key}`]?.length) {
                allTaxes[`arrayFrom${key}`].map((taxClient) => {
                  let alreadyExistsTaxes = taxes.find(tax => tax.feeType == taxClient.feeType);
                  if (!alreadyExistsTaxes) {
                    taxes.push(taxClient);
                  }
                })
              }
            }
          }
        } else {
          for (const fac of insurersTaxes) {
            for (const insurer of fac.insurers) {
              for (const key of ['clientTaxes', 'insurerTaxes']) {
                if (insurer[key]?.length) {
                  insurer[key].map((tax) => {
                    tax.idPersonInsurer = insurer?.idPersonInsurer,
                      tax.insurer = insurer?.nmInsurer,
                      tax.facility = insurer?.nbiRequestInsurerResponse?.facilityName
                    tax.idQuestionnaireAnswer = insurer?.nbiRequestInsurerResponse?.idQuestionnaireAnswer
                  })
                  taxes.push(...insurer[key]);
                }
              }
            }
          }
        }

        let insurerGroupAux = JSON.parse(JSON.stringify(insurersAll || insurerGroup));
        insurerGroupAux = [insurerGroupAux[0].map(question => {
          const { defaultValue } = question.behaviorObject || {};
          question.answer = defaultValue || "";
          question.answerJson = defaultValue || "";
          question.idAnswerOption = null;
          question.idPerson = null;
          question.idQuestionnaireAnswers = null;
          question.idQuestionnaireAnswersParent = null;
          question.idQuestionnaireAnswersRoot = null;
          question.key = null;
          return question;
        })];

        if (taxes.length && insurerGroupAux.length) {
          qtdTaxes = taxes?.length - insurerGroupAux?.length;

          while (qtdTaxes !== 0) {
            for (const [indexFac, fac] of insurerGroupAux.entries()) {
              if (qtdTaxes == 0) {
                break;
              } else {
                insurerGroupAux = [...insurerGroupAux, removeAnswersDuplicateSession(fac)]
                qtdTaxes = qtdTaxes - 1;
              }
            }
          }

          for (const [indexInsurer, insurer] of insurerGroupAux.entries()) {
            for (const [indexQuestion, question] of insurer.entries()) {
              if (isGrouped && canGroup) {
                if ([1378, 1379].includes(question.idQuestion)) {
                  question.answer = JSON.stringify({ value: "All" || "", id: -1 });
                  question.answerJson = JSON.stringify({ value: "All" || "", id: -1 });
                  question.disabled = true;
                }
              } else {
                if (question.idQuestion == 1378) {
                  question.answer = JSON.stringify({ value: taxes[indexInsurer].insurer, id: taxes[indexInsurer].idPersonInsurer });
                  question.answerJson = JSON.stringify({ value: taxes[indexInsurer].insurer, id: taxes[indexInsurer].idPersonInsurer });
                  question.disabled = true;
                } else if (question.idQuestion == 1379) {
                  question.answer = JSON.stringify({ value: taxes[indexInsurer].facility, id: taxes[indexInsurer].idQuestionnaireAnswer });
                  question.answerJson = JSON.stringify({ value: taxes[indexInsurer].facility, id: taxes[indexInsurer].idQuestionnaireAnswer });
                  question.disabled = true;
                }
              }
              if (question.idQuestion == 1380) {
                question.answer = JSON.stringify({ value: taxes[indexInsurer].feeType || "", id: taxes[indexInsurer].feeTypeDomain });
                question.answerJson = JSON.stringify({ value: taxes[indexInsurer].feeType || "", id: taxes[indexInsurer].feeTypeDomain });
                question.disabled = true;
              } else if (question.idQuestion == 1381) {
                question.answer = JSON.stringify({ value: taxes[indexInsurer].taxType || "", id: taxes[indexInsurer].taxTypeDomain });
                question.answerJson = JSON.stringify({ value: taxes[indexInsurer].taxType || "", id: taxes[indexInsurer].taxTypeDomain });
                question.disabled = true;
              } else if (question.idQuestion == 1382) {
                question.answer = JSON.stringify({ value: taxes[indexInsurer].rateBasis || "", id: taxes[indexInsurer].rateBasisDomain });
                question.answerJson = JSON.stringify({ value: taxes[indexInsurer].rateBasis || "", id: taxes[indexInsurer].rateBasisDomain });
                question.disabled = true;
              } else if (question.idQuestion == 1383) {
                question.answer = JSON.stringify({ value: taxes[indexInsurer].chargeType || "", id: taxes[indexInsurer].chargeTypeDomain });
                question.answerJson = JSON.stringify({ value: taxes[indexInsurer].chargeType || "", id: taxes[indexInsurer].chargeTypeDomain });
              } else if (question.idQuestion == 1384) {
                if (taxes[indexInsurer].chargeTypeDomain === 629 && !isNaN(taxes[indexInsurer].feeValue)) {
                  question.answer = String((taxes[indexInsurer].feeValue * 100).toFixed(5)) || "";
                } else {
                  question.answer = taxes[indexInsurer].feeValue || "";
                }
              } else if (question.idQuestion == 1465) {
                question.answer = JSON.stringify({ value: taxes[indexInsurer].government?.PERSON_LAST_NAME || "", id: taxes[indexInsurer].government.ID_PERSON });
                question.answerJson = JSON.stringify({ value: taxes[indexInsurer].government?.PERSON_LAST_NAME || "", id: taxes[indexInsurer].government?.ID_PERSON });
                question.disabled = true;
              }
            }
          }
        }

        insurerGroupAux.map(taxRow => {
          taxRow = handleQuestionsInitialAdjustments(taxRow, null, operation);
        })

        setInsurerGroup(JSON.parse(JSON.stringify(insurerGroupAux)) || []);
        setCanGroup(canGroup);
        setIsGrouped(isGrouped && canGroup);

        if (!canGroup) {
          setCanGroup(canGroup);
          areTaxesLevelUpdate = questionnaireAnswers.length ? questionnaireAnswers.find(q => q.idQuestion == 1377) : questionnaire.find(q => q.idQuestion == 1377);
          areTaxesLevelUpdate.answer = 'No';
          areTaxesLevelUpdate.idAnswerOption = 6810;

          if (questionnaireAnswers.length) {
            questionnaireAnswers = [...questionnaireAnswers.filter(q => q.idQuestion != 1377), areTaxesLevelUpdate];
          } else {
            setQuestionnaire(JSON.parse(JSON.stringify([...questionnaire.filter(q => q.idQuestion != 1377), areTaxesLevelUpdate])));
          }
        }
        loading.stop();
      }
    } catch (error) {
      mc.error("An error happened, please try again");
      console.log("error: ", error);
      console.log("logica e", error)
      return;
    }
  }

  function removeMask(value, isPercentage) {
    if (typeof value === 'number' || !value) return value;

    let maskCurrency = IMask.createMask(isPercentage ? maskPercentage : mask);
    maskCurrency.resolve(value);
    var valueUnformated = maskCurrency.unmaskedValue;
    return parseFloat(valueUnformated);
  }


  const handleExport = async () => {
    loading.start();
    const idOperation = parseInt(props.match.params.idOperation);

    let name;
    fitinsur.setAuthToken(authContext.token);
    fitinsur.generateExceXLS({ idOperation: idOperation })
      .then(x => {
        if (x.status === 200) {
          name = x.headers.get('Content-Disposition');
          return x.blob();

        } else { return x.text() }
      }).then(res => {

        try {
          if (testJSON(res)) {
            res = JSON.parse(res);
            mc.error(res.ret_msg_details);
            loading.stop();
            return;
          }
          const url = window.URL.createObjectURL(res);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;

          name = (name.split('='))[1].replace('"', '');
          a.download = name.substring(0, name.length - 1);
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          loading.stop();
          setExported(!isExported);
        } catch (e) {
          mc.error("An error happened, please try again");
          loading.stop();
          return;
        }
      })
  };

  const handleReset = () => {
    setExported(false)
    setImported(false);
  };


  function handleEndorsementDoc() {
    useEndorsementDocRequest({ idOperation: props.match.params.idOperation }, null).then(({ data: resp }) => {
      if (resp.ret_code !== 200) {
        mc.error(resp.ret_msg_details);
        return;
      }
      history.push(`/broking/endorsement-${endorsmentType}/${props.match.params.idOperation}`);
    }).catch();
  };


  function handleConfirmReset(a) {
    setConfirmed({
      visible: true,
      title: "CONFIRM RESET?",
      icon: "TimesCircle",
      args: a,
    });
  }

  async function handleGenerateMrc() {
    history.push(`/broking/mrc-complementary/${props.match.params.idOperation}`)
  }

  const handleLock = (a, values) => {
    try {
      if (a) {
        let body = {
          idOperation: parseInt(props.match.params.idOperation),
          bolSaveLineSize: true,
          facilities: values.facilities.map((facility) => {
            facility.insurers = facility.insurers.map((item) => {
              let it = {
                idPersonInsurer: item.idPersonInsurer,
                lineSize: item.lineSize,
                percLineSize: item.percLineSize,
                brokerage: item.brokerage,
                idPersonLegalEntity: item.idPersonLegalEntity,
                nbiRequestInsurerResponse: item.nbiRequestInsurerResponse
              };
              return it;
            });

            return facility;
          }),
        };

        useInsurerLockRequest({ ...body }, null).then(({ data: res }) => {
          if (res.ret_code !== 200) {
            mc.error(res.ret_msg_details);
            return;
          }
          if (formik.current) {
            formik.current?.setFieldValue('lock', a);
          }

          getGridItems();
          getMasks();
          getScheduleStatus();
        }).catch(e => {
          mc.error(e.message);
          return;
        });
      } else {
        handleConfirmReset(a);
      }
    } catch {
    }
  };


  const handleTaxesAndCoverages = (answer) => {
    const toLockTaxesAndCoverages = answer && answer.idAnswerOption === 7095;
    let values = formik.current.values;

    try {
      if (toLockTaxesAndCoverages) {
        let returnPercentage = false;
        let cleanValue = removeMask(values.obligorCodingPercentage, true)
        if (parseInt(cleanValue) != 100) return mc.error('The total obligor coding percentage should be 100%.');
        if (values.obligorCodingPercentage.trim() == '%' || !values.obligorCodingPercentage || values.obligorCodingPercentage == "% 0.00000") {
          returnPercentage = true
          return
        }

        if (maxValuePerc != 100) returnPercentage = true;
        if (returnPercentage) return mc.error('The obligor coding percentage should not be different than 100.');
        const result = handleSaveQuestionnaireAnswer(values, props.match.params.idOperation);

        if (!result) return;

      }
    } catch (e) {
    }
  }

  function getLnSizeTotalByFacility(facility, facilityIndex) {
    let soma = 0;
    let somaLabel = 0;
    facility.insurers.map((item) => {
      if (!item.lineSize) {
        return;
      }

      soma = (soma + parseFloat(item.lineSize));
      if (typeof item.lineSize === 'number') {
        somaLabel = (somaLabel + parseFloat(item.lineSize));
      } else {
        somaLabel = (somaLabel + parseFloat(unformat(item.lineSize)));
      }
    });

    if (formik.current) {
      formik.current?.setFieldValue(`facilities.${facilityIndex}.lineSizeTotal`, somaLabel);
    }

    return somaLabel;
  };

  function getMaxLnSizeTotalByFacility(facility, facilityIndex) {
    let soma = 0;
    let somaLabel = 0;
    facility.insurers.map((item) => {
      if (!item.maxLineSize) {
        return;
      }

      soma = (soma + parseFloat(item.maxLineSize));
      if (typeof item.maxLineSize === 'number') {
        somaLabel = (somaLabel + parseFloat(item.maxLineSize));
      } else {
        somaLabel = (somaLabel + parseFloat(unformat(item.maxLineSize)));
      }
    });

    if (formik.current) {
      formik.current?.setFieldValue(`facilities.${facilityIndex}.maxLineSizeTotal`, somaLabel);
    }

    return somaLabel;
  };

  async function getLnSizeByFacility() {
    formik.current.values.facilities.forEach(async (facility, indexFacility) => {
      await getMaxLnSizeTotalByFacility(facility, indexFacility);
      let total = await getLnSizeTotalByFacility(facility, indexFacility);

      let lnSizeTotal = 0;
      facility.insurers.forEach((insurer, indexInsurer) => {
        let percLnSize;
        if (!insurer.lineSize) {
          if (formik.current) {
            formik.current?.setFieldValue(`facilities.${indexFacility}.insurers.${indexInsurer}.lineSize`, 0);
          }
          return;
        }
        let lineSizeConversion;
        if (typeof insurer.lineSize === 'number') {
          lineSizeConversion = parseFloat(insurer.lineSize);
        } else {
          lineSizeConversion = (parseFloat(unformat((insurer.lineSize).toString())));
        }

        percLnSize = total ? ((lineSizeConversion / total) * 100) : 0;
        lnSizeTotal = (lnSizeTotal + percLnSize);

        if (formik.current) {
          formik.current?.setFieldValue(`facilities.${indexFacility}.insurers.${indexInsurer}.percLineSize`, percLnSize)
        }

        if (formik.current && insurer.personInsurerLegalEntity) {
          formik.current?.setFieldValue(`facilities.${indexFacility}.insurers.${indexInsurer}.idPersonLegalEntity`, insurer.personInsurerLegalEntity.idPersonTail)
        }

      });

      if (formik.current) {
        formik.current?.setFieldValue(`facilities.${indexFacility}.percLnSizeTotal`, lnSizeTotal);
      }
    });
  }

  function formatMaxLimit(value) {
    let mask = maskHelper.getMaskConfig(masks, 69, authContext.region);
    if (mask) {
      mask.padFractionalZeros = true;
      return maskHelper.resolveMask(value, mask);
    }
  }


  function unformat(value) {
    if (typeof value === 'number') {
      return;
    }
    let maskCurrency = IMask.createMask(mask);
    maskCurrency.resolve(value);
    var valueUnformated = maskCurrency.unmaskedValue;
    return valueUnformated;
  }

  function format(value, bb) {
    let maskCurrency = IMask.createMask(mask);
    let formated = maskCurrency.resolve(value ? value.toString() : "0");
    return formated;
  }

  const renderOptionsNbiResponseList = NbiResponseList => {
    let result = [], entities = [];

    if (NbiResponseList.hasOwnProperty('selectedLegalEntities')) {
      entities = NbiResponseList.selectedLegalEntities;
    } else {
      entities = NbiResponseList.legalEntities;
    }

    entities.forEach(element => {
      result.push({
        label: element.insured_legal_entity,
        value: element.idPersonLegalEntity,
      });
    });

    return result;
  };

  const createValidation = () => {
    let validationFacility = {}
    let validationSchema = {}
    let validationInsurer = {};

    for (let f = 0; f < facilities.length; f++) {
      for (let i = 0; i < facilities[f].insurers.length; i++) {
        validationInsurer[`idPersonLegalEntity`] = yup.string().required("* Required field");
      }
    }

    validationFacility.insurers = yup.array().of(yup.object().shape(validationInsurer)).test({
      name: 'first-and-last',
      message: "* Required field",
      test: val => val.every(({ idPersonLegalEntity }, index) => {
        return !!idPersonLegalEntity;
      })
    })

    validationSchema.facilities = yup.array().of(yup.object().shape(validationFacility))
    return validationSchema
  }

  const buildValidation = (questionnaireSaved, taxesAndCoverages) => {
    try {
      const validationSchema = {};
      let validationSchemaOld = {};

      if(taxesAndCoverages) { 
        const questionnaire = questionnaireSaved ? handleSaveQuestionnaireAnswer(questionnaireSaved, false, true) : handleSaveQuestionnaireAnswer(formik?.current?.values, false, true);

        for (const question of questionnaire || []) {
          if (question.idQuestion == 759) {
            validationSchema[question.key] = yup.object().required("* Required field");
          } else if (question.idQuestion == 760 && !question.disabled) {
            validationSchema[question.key] = yup.string().required("* Required field");
          } else {
            validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
              ? yup.string().test("answer-validation", "Required Field", function (value) {
                return !!question.answer;
              }) : yup.string().notRequired();
          }
        }
      } else { 
        validationSchemaOld = createValidation();
      }
      
      
      let validationSchemaFinal = { ...validationSchema, ...validationSchemaOld }
      setValidation(yup.object().shape(validationSchemaFinal))
      return yup.object().shape(validationSchemaFinal);
    } catch (e) {

    }
  }

  const renderFlowClient = (formikProps) => {
    if (isClient) return <></>

    return (
      <>
        <HasPermission permission={props.permissions.MARKETS_SELECTION}>
          <Button
            third
            style={{ marginLeft: "10px", marginTop: "5px" }}
            onClick={(e) => {
              history.push(
                `/broking/market-selection/${quotationOperationId || props.match.params.idOperation}`,
                {
                  idOperation: props.match?.params?.idOperation || null,
                  idProduct: props.location?.state?.idProduct || null
                }
              )
            }}
          >
            UPDATE NBI
          </Button>
        </HasPermission>
        {
          isExported ? (
            <>
              {
                isImported ?
                  (
                    <> 
                      <Button
                        third
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        name="viewSchedule"
                        id="viewSchedule"
                        onClick={() => {
                          let idOperationRediret = isUpdatedSchedule ? idOperationRedirect : props.match.params.idOperation;

                          if (isUpdatedSchedule) {
                            history.push(`/broking/schedule-exibition-updated-schedule/${idOperationRediret}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null });
                          } else {
                            history.push(`/broking/schedule-exibition/${idOperationRediret}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null });
                          }
                        }}>
                        VIEW SCHEDULE
                      </Button>

                      <HasPermission
                        permission={props.permissions.GENERATE_WORDING}
                      >
                        <Button
                          primary
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          onClick={() => handleGenerateMrc()}>
                          GENERATE MRC
                        </Button>
                      </HasPermission>

                    </>
                  ) : (
                    <HasPermission
                      permission={props.permissions.IMPORT_SCHEDULE}
                    >
                      <PlaceHolder style={{ marginTop: "5px" }} disabled={!lockAndSaveCoverages} primary htmlFor="fileInput">IMPORT</PlaceHolder>
                      <TagInput id="fileInput" name="fileInput" disabled={!lockAndSaveCoverages} type="file" multiple={false} onChange={(event) => { handleUpload(event, formikProps); formikProps?.setFieldValue('fileInput', '') }} />
                    </HasPermission>
                  )
              }
            </>
          ) : (
            <HasPermission
              permission={props.permissions.EXPORT_SCHEDULE}
            >
              {<Button primary onClick={() => { handleExport() }} disabled={!formikProps.values.lock} style={{ marginLeft: "10px", textAlign: "center", marginTop: "5px" }}>EXPORT</Button>}
            </HasPermission>
          )
        }
      </>
    )
  }

  const handleCreateMarketChangeQuotation = () => {
    useCreateMarketChangeQuotationRequest({ idOperation: props.match.params.idOperation }, null).then(({ data: resp }) => {
      if (resp.ret_code !== 200) {
        mc.error(resp.ret_msg_details);
        return;
      }

      history.push(`/broking/market-selection/${resp?.ret_value.quotationOperationId || props.match?.params?.idOperation}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null })
    }).catch(e => {
    });
  }

  const handleContactsForNBIUpdate = (item) => {
    const insurerFiltered = [...contacts.filter(insurer => insurer.idPersonRoot === item.idPersonInsurer)];

    const insurer = {
      idPersonInsurer: item.idPersonInsurer,
      contacts: insurerFiltered[0].contacts,
      insurerFirstName: insurerFiltered[0].insurerFirstName
    }

    setInsurerContacts(insurer);
    setModalUnderwriter(true);
  }

  const handleUpdateNBIManually = (insurer, underwriters) => {
    const idOperation = props.match.params.idOperation;

    if (!underwriters.length) {
      mc.error('Select at least one underwriter');
      return;
    }

    useUpdateNBIManuallyRequest({ idOperation: idOperation, insurer: insurer, underwriters: underwriters }, null).then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      setSelectedUnderwriters([])
      window.open(data.ret_value, '_blank');
    });
  }

  useEffect(() => {
    if (retry > 0 && retry < 21) {
      useImportStatusRequest().then(({ data: res }) => {
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details, true);
          setRetry(0);
          return;
        }

        let idOperationRediret = isUpdatedSchedule ? idOperationRedirect : props.match.params.idOperation;
        if (res.ret_value.idDomainStatus) {
          if (res.ret_value.idDomainStatus === 35) {
            if (isUpdatedSchedule) {
              history.push(`/broking/schedule-exibition-updated-schedule/${idOperationRediret}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null });
            } else {
              history.push(`/broking/schedule-exibition/${idOperationRediret}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null });
            }
            setRetry(0);
          } else if (res.ret_value.idDomainStatus === 36) {
            if (res.ret_value.errorsImportSchedulle) {
              res.ret_value.errorsImportSchedulle.forEach((i) => {
                if (i.ret_msg_details) {
                  mc.error(i.ret_msg_details);
                }
              })
            }
            setRetry(0);
          } else {
            setTimeout(() => setRetry(retry + 1), 750)
          }
        }
      }).catch(() => { setRetry(0) })
    } else if (retry === 21) {
      mc.error('Import Timeout');
      setRetry(0);
    } else if (retry === 0) {
    }
  }, [retry])

  const endorsementButton = (formikProps) => {

    let route = null;

    if (endorsmentType === 'market-changes') route = 'risk-and-market-changes-edit';
    if (endorsmentType === 'not-pre-agreed') route = 'not-pre-agreed-edit';
    if (endorsmentType === 'cancellation') route = 'cancellation-edit';


    if (route && (endorsmentType === 'not-pre-agreed' || endorsmentType === 'cancellation')) {
      return (
        <>
          <PlaceHolder style={{ marginTop: "5px" }} primary htmlFor="fileInput">IMPORT</PlaceHolder>
          <TagInput id="fileInput" name="fileInput" type="file" multiple={false} onChange={(event) => { handleUpload(event, formikProps); formikProps?.setFieldValue('fileInput', '') }} />
          <NewButton
            primary
            style={{ marginLeft: "10px", marginTop: "5px" }}
            onClick={() => { history.push(`/broking/${route}/${props.match.params.idOperation}`) }}>
            GENERATE ENDORS. DOC
          </NewButton>
        </>
      )
    } else if (route && endorsmentType == 'market-changes') {
      return (
        <Button
          primary
          style={{ marginLeft: "10px", marginTop: "5px" }}
          onClick={() => handleGenerateMrc()}>
          GENERATE MRC
        </Button>
      )
    } else if (route) {
      return (
        <Button
          primary
          style={{ marginLeft: "10px", marginTop: "5px" }}
          onClick={() => { history.push(`/broking/${route}/${props.match.params.idOperation}`) }}>
          GENERATE ENDORS. DOC
        </Button>
      )
    }

    return (
      <Button
        primary
        style={{ marginLeft: "10px" }}
        onClick={() => handleEndorsementDoc()}>
        ENDORSEMENT DOC
      </Button>
    )
  }

  const renderAddAndRemoveButtons = (array, index, questions, setFunction, partySectionName, values) => {
    return (
      <>
        {index !== 0 ?
          <AddButton style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction(array.filter((v, i) => i !== index));
            setQuestionnaireAnswersToDelete([
              ...questionnaireAnswersToDelete,
              ...questions.map(
                question => question.idQuestionnaireAnswers
              ).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
            ])
          }}>
            <Icon name="trash" style={{ margin: 0, width: '49.5px' }} />
          </AddButton> : <></>}
        {index === array.length - 1 ?
          <AddButton style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction([...array, removeAnswersDuplicateSession(questions)]);
          }}>
            <Icon name="plus" style={{ margin: 0 }} />
          </AddButton> : <></>}
      </>
    )
  }

  const renderAddButtons = (array, index, questions, setFunction, partySectionName, values) => {
    return (
      <>
        {index === array.length - 1 ?
          <AddButton style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction([...array, removeAnswersDuplicateSession(questions)]);
          }}>
            <Icon name="plus" style={{ margin: 0 }} />
          </AddButton> : <></>}
      </>
    )
  }

  function validateRenderButtons(questions) {
    let renderButtons = false;
    let nmInsurer;
    let facilityName;
    let taxName;

    nmInsurer = questions.find(q => q.idQuestion == 1378)?.answer ? JSON.parse(questions.find(q => q.idQuestion == 1378)?.answer)?.value : null;
    facilityName = questions.find(q => q.idQuestion == 1379)?.answer ? JSON.parse(questions.find(q => q.idQuestion == 1379)?.answer)?.value : null;
    taxName = questions.find(q => q.idQuestion == 1380)?.answer ? JSON.parse(questions.find(q => q.idQuestion == 1380)?.answer)?.value : null;

    if (!nmInsurer || !facilityName || !taxName) {
      return renderButtons;
    }
    if (isGrouped) {
      insurersTaxes.map(fac => fac.insurers.map(insurer => {
        insurer?.clientTaxes?.map(taxClient => {
          if (taxClient?.feeType == taxName) {
            renderButtons = true;
          }
        })
        insurer?.insurerTaxes?.map(taxInsurer => {
          if (taxInsurer?.feeType == taxName) {
            renderButtons = true;
          }
        })
      }));
    } else {
      insurersTaxes.map(fac => fac.insurers.map(insurer => {
        let tax = insurer?.clientTaxes?.find(tax => (insurer?.nmInsurer == nmInsurer && fac?.name == facilityName && tax?.feeType == taxName)) || insurer?.insurerTaxes?.find(tax => (insurer?.nmInsurer == nmInsurer && fac?.name == facilityName && tax?.feeType == taxName));
        if (tax) {
          renderButtons = true;
        }
      }));
    }

    return renderButtons;
  }

  useEffect(() => {
    if (isMAS || isNewYork) {
      let total = 0;
      obligorGroup.map((group, index) => {
        let question = group.find(item => item.idQuestion == 760);
        let value = parseFloat(formik.current.values[`${question.key}`]) ? parseFloat(formik.current.values[`${question.key}`]) : 0;
        if (!question.answer || question.answer == "") value = 0;
        total += value;
      })
      setMaxValuePerc(total);
      formik.current?.setFieldValue(`obligorCodingTotal`, total);
    } else {
      setMaxValuePerc(100);
      formik.current?.setFieldValue(`obligorCodingTotal`, 100);
    }

  }, [obligorGroup]);

  useEffect(() => {
    if (idProduct && questionnaire) {
      if (!isMAS && !isNewYork) {
        let obligorGroupAux = obligorGroup.map((groups, index) => {
          groups.map((group) => {
            if (group.idQuestion == 760) {
              group.disabled = true;
              if (!group.answer) {
                group.answer = '100';
                formik.current?.setFieldValue(`${group.key}`, 100);
              }
            }
          })
          return groups;
        })
        setObligorGroup(obligorGroupAux)
      } else {
        let obligorGroupAux = obligorGroup.map((groups, index) => {
          groups.map((group) => {
            if (group.idQuestion == 760) {
              group.disabled = false;
              if (group.answerJson && group.answer && group.answer != group.answerJson) {
                group.answer = group.answerJson;
                formik.current?.setFieldValue(`${group.key}`, group.answerJson);
              }
            }
          })
          return groups;
        })
        setObligorGroup(obligorGroupAux)
      }
    }

  }, [isMAS, isNewYork, idProduct, questionnaire]);


  useEffect(() => {
    let mask = maskHelper.getMaskConfig(masks, 69, authContext.region);
    if (mask) {
      mask.padFractionalZeros = true;
    }
  }, [maxLimit, masks]);

  useEffect(() => {
    if (formik.current) {
      formik.current?.setFieldValue("facilities", data);
    }

    setTimeout(function () {
      if (formik?.current?.values?.facilities) {
        getLnSizeByFacility();
      }
    }, 1500)

  }, [data])

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      if (props.match.params.idOperation && questionnaireAnswersToDelete.length) {
        useDeleteQuestionnaireAnswerRequest({ ids: questionnaireAnswersToDelete });
      } else {
        useGetQuestionnairesAnswersRequest();
      }

      useSaveInsurerTaxesRequest().then(() => {
        setExported(false);
        setImported(false);
        getScheduleStatus();
      });
    }

    if (useSaveQuestionnaireAnswerStatus === 400) {
      useSaveQuestionnaireAnswerError.errors?.map(error => {
        if (error.message) mc.error(error.message)
      })
    }
  }, [useSaveQuestionnaireAnswerStatus]);


  const handleOperationInfo = () => {
    useOperationInfoRequest().then(({ data }) => {
      setIdProduct(data.idProduct);
      setIsBound(data.isBound || false)
      setOperation(data)
      setUpdateNBIManually(data.updateNBIManually || false)
      setIsNewYork(data.isNewYork);
      setIsMAS(data.isMas);
    })
  }

  function handleSelectUnderwriter(contact) {
    const select = {
      name: contact.nameContact,
      email: contact.email,
      idContact: contact.idContact
    };

    const alreadySelected = selectedUnderwriters.find((item) => item.idContact === select.idContact);

    if (alreadySelected) {
      const signers = selectedUnderwriters.filter(item => item.idContact !== select.idContact);
      setSelectedUnderwriters(signers);
    } else {
      setSelectedUnderwriters([select, ...selectedUnderwriters])
    }
  };

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
    handleOperationInfo();
    getInsurersTaxes();
    getGridItems();
    getMasks();
    handleSummary();
    listContacts();
    getScheduleStatus();
    useGetQuestionnairesAnswersRequest();
  }, []);

  const SECTIONS = {
    OBLIGOR_PERC: { name: 'OBLIGOR_PERC', isMultiple: true, isRisk: false },
    INSURER_TAXES: { name: 'INSURER_TAXES', isMultiple: true, isRisk: false },
    TAX_RATES: { name: 'TAX_RATES', isMultiple: false, isRisk: false },
    LOCK_AND_SAVE_COVERAGES_TAXES: { name: 'LOCK_AND_SAVE_COVERAGES_TAXES', isMultiple: false, isRisk: false }
  };

  const handleSaveQuestionnaireAnswer = (values, idOperation, onlyQuestions) => {
    const formValues = JSON.parse(JSON.stringify(values));
    const body = { questionnaireAnswers: [] };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          case 'OBLIGOR_PERC':
            multipleFields = obligorGroup;
            break;
          case 'INSURER_TAXES':
            multipleFields = insurerGroup;
            break;
          default:
            multipleFields = [];
            break;
        }
        multipleFields.map((field, index) => {
          let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
          if (sectionAnswers?.length) {
            const rootQuestion = sectionAnswers.find(question => !question.idQuestionRoot);
            const childrenQuestions = sectionAnswers.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions
            if (!onlyQuestions) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
            }
          }
        })
      } else {
        let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
        if (sectionAnswers) {
          body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
        }
      }
    }

    body.questionnaireAnswers = body.questionnaireAnswers.filter(question => {
      return question !== 1378 || (question === 1378 && question.answer)
    })

    for (const question of body.questionnaireAnswers) {
      if ((question.idDomainQuestion === 270 || question.idDomainQuestion === 271) && question.answer) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }
    }
    if (onlyQuestions) return body.questionnaireAnswers;

    if (idOperation) {
      var total = 0
      const percentage = body.questionnaireAnswers.filter(question => question.idQuestion === 760);

      if (!percentage.length) total = 100;
      percentage.map((qst) => {
        if (percentage.length === 1 && !qst.answer) return total = 100;
        const question = qst.childrenQuestions?.find(v => v.idQuestion === 1192)
        if (question) total += parseFloat(question.answer || 0)
      });

      if (total !== 100) {
        mc.error('The total obligor coding percentage should be 100%.')
        return false;
      } else {
        if (!props.match?.params?.idOperation) questionnaireSent.current = true;

        if (body.questionnaireAnswers) {
          let allTaxesGrouped = body.questionnaireAnswers.find(q => q.idQuestion == 1377)?.answer;
          let taxesQuestion = body.questionnaireAnswers.filter(q => q.idQuestion == 1378);
          let hasDuplicatedTax = false;
          let taxNames = [];

          if (allTaxesGrouped == "Yes") {
            taxesQuestion.map((q) => {
              if (taxNames.includes(q.childrenQuestions.find(tax => tax.idQuestion == 1380)?.answer)) {
                hasDuplicatedTax = true;
              } else {
                taxNames.push(q.childrenQuestions.find(tax => tax.idQuestion == 1380)?.answer);
              }
            })
          } else {
            taxesQuestion.map((q) => {
              let obj = {
                nameInsurer: JSON.parse(q.answer)?.value,
                nameFacility: JSON.parse(q.childrenQuestions.find(tax => tax.idQuestion == 1379)?.answer)?.value,
                taxName: JSON.parse(q.childrenQuestions.find(tax => tax.idQuestion == 1380)?.answer)?.value,
              }
              if (!taxNames.length) {
                taxNames.push(obj);
              } else {
                let alreadyExistsTax = taxNames.find(tax => (tax.nameInsurer == obj.nameInsurer && tax.nameFacility == obj.nameFacility && tax.taxName == obj.taxName));
                if (!alreadyExistsTax) {
                  taxNames.push(obj);
                } else {
                  hasDuplicatedTax = true;
                }
              }
            })
          }

          if (hasDuplicatedTax) {
            mc.error('Duplicate taxes for the same insurer are not allowed!');
            return false;
          } else {
            useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
            return true;
          }
        }
      }
    }
  }

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 400) {
      useSaveQuestionnaireAnswerError.errors?.map(error => {
        if (error.message) mc.error(error.message)
      })
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  function getObligorCodingPercentage(element, index, values) {
    if (!element.answer || element.answer == "") element.answer = 0
    let answer = parseFloat(removeMask((element.answer)));
    let total = formik.current.values.obligorCodingTotal;
    if (!obligorGroup[index][1].answer || obligorGroup[index][1].answer == "") obligorGroup[index][1].answer = 0
    let oldValue = parseFloat(removeMask(((obligorGroup[index][1].answer).toString())));
    if (oldValue == 0 || !oldValue) {
      oldValue = values[`${element.key}_old`] ? parseFloat(removeMask(((values[`${element.key}_old`]).toString()))) : 0
    }

    let finalValue = answer - oldValue;

    let somaLabel = 0;
    if (total) somaLabel = total;
    if (typeof answer === 'number') {
      somaLabel = (somaLabel + parseFloat(removeMask((finalValue))));
    } else {
      somaLabel = (somaLabel + parseFloat(removeMask((finalValue))));
    }

    let obligorGroupAux = obligorGroup;
    obligorGroupAux.map((item, ind) => {
      if (ind == index) {
        item[1].answer = answer;
      }
    })
    setObligorGroup(obligorGroupAux)
    if (isNaN(somaLabel)) somaLabel = 0;
    setMaxValuePerc(somaLabel);
    formik.current?.setFieldValue(`obligorCodingTotal`, somaLabel);

  };

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.nmObligor
        ? summary.nmObligor
        : "Broking name"
      }
      subtitle={summary.dealCode
        ? summary.dealCode
        : "Deal Code"
      }
    >
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      <ContentCard
        title={endorsmentTypeEnum[endorsmentType]
          ? endorsmentTypeEnum[endorsmentType].title
          : "MARKET COMPOSITION"
        }
        icon
        info={{
          idOperation: props.match?.params?.idOperation || null,
          idProduct: props.location?.state?.idProduct || null
        }}
      >
        <DialogComponent
          icon={confirmed.icon}
          title={confirmed.title}

          show={confirmed.visible}
          setDialog={setConfirmed}>

          <DialogCancel onClick={() => { setConfirmed({ visible: false, title: null, icon: null, args: null }) }}>Cancel</DialogCancel>
          <DialogConfirm onClick={() => { setConfirmed({ visible: false, title: null, icon: null, args: null }); formik.current?.setFieldValue('lock', confirmed.args); handleReset();}}>Confirm</DialogConfirm>

        </DialogComponent>
        <>
          <Formik
            initialValues={{ lock: false, lockCoverageTaxes: "No", insurers: [], facilities: [], attachments: [], documentType: [], obligorCoding: '', obligorCodingPercentage: "100", obligorCodingTotal: '100' }}
            innerRef={formik}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize={true}
          >
            {formikProps => (
              <Form>
                <Scrollbox>
                  {formikProps.values.facilities.map((facility, facilityIndex) => (
                    <>
                      <Row style={{ display: "flex", paddingBottom: "15px", justifyContent: "center", alignItems: "center" }}>
                        <Col>
                          <Text secundary>{facility.name ? facility.name : 'MAIN CONTRACT'} - REQUESTED LIMIT OF LIABILITY {facility.facility_currency || ''} {formatMaxLimit(facility.max_limit_of_liability)}</Text>
                        </Col>
                      </Row>

                      <div style={{ marginLeft: 15, marginRight: 15 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              {coluns.map((column, index) => (
                                <TableHeader
                                  key={index}
                                  minWidth={column.minWidth}
                                  maxWidth={column.maxWidth}
                                  style={{ paddingLeft: index === 1 ? '40px' : 'unset' }}
                                >
                                  <Text style={{ fontSize: 15, margin: "0 auto", textTransform: "uppercase" }}>
                                    {column.title === 'Brokerage' && isClient ? '' : column.title}
                                  </Text>
                                  {column.value &&
                                    sortBy.key === column.value &&
                                    sortBy.direction === "asc" ? (
                                    <Icon name={"arrowup"} />
                                  ) : column.value &&
                                    sortBy.key === column.value &&
                                    sortBy.direction === "desc" ? (
                                    <Icon name={"arrowdown"} />
                                  ) : (
                                    ""
                                  )}
                                </TableHeader>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <FieldArray
                              name="insurers"
                              render={() =>
                                facility.insurers.map((item, index) => (
                                  <>
                                    <TableRow key={index}>
                                      <TableCollum>
                                        <InlineLabel>Insurer</InlineLabel>
                                        <Text style={{ whiteSpace: "nowrap", fontWeight: "bold" }}>{item.nmInsurer}</Text>
                                      </TableCollum>

                                      <TableCollum>
                                        <InlineLabel>Legal Entity</InlineLabel>
                                        <Field
                                          name={`facilities.${facilityIndex}.insurers.${index}.idPersonLegalEntity`}
                                          component={ComboBox}
                                          options={renderOptionsNbiResponseList(item.nbiRequestInsurerResponse)}
                                          value={formikProps.values.facilities[facilityIndex].insurers[index].idPersonLegalEntity}
                                          onChange={(e) => {
                                            formik.current?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.idPersonLegalEntity`, e);
                                          }}
                                          disabled={formikProps.values.lock || isBound || isClient}
                                          style={{ width: '150px', marginRight: '19px', cursor: 'pointer', fontWeight: "bold", color: 'gray', marginLeft: '40px' }}
                                          isRequired
                                        />
                                      </TableCollum>

                                      <TableCollum>
                                        <InlineLabel>Max Line Size</InlineLabel>
                                        <Text style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>{maskHelper.resolveMask(item?.maxLineSize, maskHelper.getMaskConfig(masks, 69, authContext.region, facility.max_limit_of_liability || null, true))}</Text>
                                      </TableCollum>

                                      <TableCollum>
                                        <InlineLabel>Premium Rate</InlineLabel>
                                        <Text style={{ whiteSpace: "nowrap", fontWeight: "bold" }}>{maskHelper.resolveMask(item?.premiumRate, maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true))}</Text>
                                      </TableCollum>

                                      <TableCollum>
                                        <InlineLabel>Line Size</InlineLabel>
                                        {formikProps.values.lock || isClient ? (
                                          <Text style={{ whiteSpace: "nowrap" }}>{format(formikProps.values.facilities[facilityIndex].insurers[index].lineSize, true)}</Text>
                                        ) : (
                                          <Field
                                            disabled={formikProps.values.lock || isBound}
                                            name={`facilities.${facilityIndex}.insurers.${index}.lineSize`}
                                            value={format(formikProps.values.facilities[facilityIndex].insurers[index].lineSize, true)}
                                            mask={maskHelper.getMask("currency", authContext.region, 2, 12, item?.maxLineSize, 0)}
                                            onChange={e => {
                                              if (item?.maxLineSize < e) {
                                                formikProps?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.lineSize`, item?.maxLineSize)
                                              } else {
                                                formikProps?.setFieldValue(`facilities.${facilityIndex}.insurers.${index}.lineSize`, e)
                                              }
                                            }}
                                            component={InputField}
                                            onBlur={() => { getLnSizeByFacility() }}
                                            validation={false}
                                            style={{ width: '100px', cursor: 'pointer', fontWeight: "bold", color: 'gray' }}
                                          />
                                        )}
                                      </TableCollum>


                                      <TableCollum>
                                        <InlineLabel>Line Size %</InlineLabel>
                                        <Text style={{ whiteSpace: "nowrap", fontWeight: "bold" }}>%{item?.percLineSize?.toFixed(5)}</Text>
                                      </TableCollum>

                                      {!isClient ?
                                        <TableCollum>
                                          <InlineLabel>Brokerage</InlineLabel>
                                          {formikProps.values.lock ?
                                            <Text style={{ whiteSpace: "nowrap", fontWeight: "bold" }}>{maskHelper.resolveMask(formikProps.values.facilities[facilityIndex].insurers[index].brokerage, maskHelper.getPercentage(authContext.region, 5, "100.00", "0", true))}</Text>
                                            :
                                            <Field
                                              name={`facilities.${facilityIndex}.insurers.${index}.brokerage`}
                                              mask={maskHelper.getPercentage(authContext.region, 5, "100.00")}
                                              value={formikProps.values.facilities[facilityIndex].insurers[index].brokerage}
                                              component={InputField}
                                              validation={false}
                                              disabled={formikProps.values.lock || isBound}
                                            />
                                          }
                                        </TableCollum> : <TableCollum></TableCollum>}
                                      <TableCollum>
                                        <Col>
                                          <Icon
                                            name={!formikProps.values.lock && (!endorsmentType || endorsmentType === 'declaration') && updateNBIManually ?
                                              'edit-grey' : 'edit-grey-disabled'
                                            }
                                            title={'Update NBI Request Manually'}
                                            onClick={() => {
                                              if (!formikProps.values.lock && (!endorsmentType || endorsmentType === 'declaration') && updateNBIManually && contacts.length) handleContactsForNBIUpdate(item);
                                            }}
                                            style={{
                                              cursor: !formikProps.values.lock && (!endorsmentType || endorsmentType === 'declaration') && updateNBIManually ?
                                                'pointer' : 'not-allowed'
                                            }}
                                          />
                                        </Col>
                                      </TableCollum>
                                    </TableRow>
                                  </>
                                ))
                              }
                            />
                            <TableRow>
                              <TableCollum>
                                <Text secundary>TOTAL</Text>
                              </TableCollum>
                              <TableCollum style={{ display: "flex", textAlign: "center", justifyContent: "center", fontWeight: "bold", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                                <Text style={{ whiteSpace: "nowrap" }}> </Text>
                              </TableCollum>
                              <TableCollum style={{ marginLeft: "0px", justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                                <Text style={{ whiteSpace: "nowrap" }}>{format(facility.maxLineSizeTotal)}</Text>
                              </TableCollum>
                              <TableCollum style={{ display: "flex", textAlign: "center", justifyContent: "center", fontWeight: "bold", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                                <Text style={{ whiteSpace: "nowrap" }}> </Text>
                              </TableCollum>
                              <TableCollum style={{ marginLeft: "0px", justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                                <Text style={{ whiteSpace: "nowrap" }}>{format(facility.lineSizeTotal)}</Text>
                              </TableCollum>
                              <TableCollum style={{ marginLeft: "0px", justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                                <Text style={{ whiteSpace: "nowrap" }}>% {facility.percLnSizeTotal ? facility.percLnSizeTotal.toFixed() : 0}</Text>
                              </TableCollum>
                              <TableCollum style={{ textAlign: "center", marginLeft: "0px", justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                                <Text style={{ whiteSpace: "nowrap" }}> </Text>
                              </TableCollum>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </div>
                    </>
                  ))}
                  <>

                    <RowLockAndSave style={{ marginTop: 40, marginBottom: 100 }}>
                      <Col style={{ maxWidth: 210 }}>
                        <Label>
                          <strong style={{ fontWeight: 600, fontSize: 15 }}> Lock and save Line Size.</strong>
                        </Label>
                      </Col>
                      <Col>
                        <BorderSwitch>
                          <Field
                            disabled={(isClient || endorsmentType && (endorsmentType !== 'declaration' && endorsmentType !== 'market-changes')) || isBound}
                            component={Switch}
                            height={27}
                            width={55}
                            name={'lock'}
                            checked={formikProps.values.lock}
                            onChange={(a) => {
                              setFacilities(formikProps.values.facilities);
                              if (!a) return handleLock(a, formikProps.values);
                              buildValidation(null, false).validate(formikProps.values, { abortEarly: false })
                                .then(() => {
                                handleLock(a, formikProps.values)
                              })
                              .catch((e) => {
                                mc.error('Please, fill in all required fields.')
                              })
                              // validation.validate(formikProps.values).then(() => handleLock(a, formikProps.values)).catch((e) => {
                              //   mc.error('Please, fill in all required fields.')
                              // });
                            }}
                            handleDiameter={20}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            offColor={Colors.WHITE}
                            onColor={Colors.GRAY[6]}
                            offHandleColor={Colors.GRAY[6]}
                            onHandleColor={Colors.WHITE}
                          />
                        </BorderSwitch>
                      </Col>
                    </RowLockAndSave>
                    {questionnaire.length > 0 ? <>
                      <div style={{ marginLeft: 15 }}>
                        <Row style={{ marginTop: 50, marginBottom: 10 }}>
                          <Title>COVERAGES</Title>
                        </Row>
                        {obligorGroup?.map((questions, index) => {
                          if (idProduct) {
                            return (
                              <FormSection
                                sectionName="OBLIGOR_PERC"
                                sectionIndex={index}
                                disableAll={lockAndSaveCoverages || isBound}
                                questionnaire={questions}
                                values={formikProps.values}
                                setFieldValue={formikProps.setFieldValue}
                                formikRef={formik}
                                extraButtons={() => {
                                  if (!isMAS && !isNewYork) return null;
                                  return renderAddAndRemoveButtons(
                                    obligorGroup,
                                    index,
                                    questions,
                                    setObligorGroup,
                                  );
                                }}
                                idOperation={props.match?.params?.idOperation}
                                idOperationParent={props.match?.params?.idOperationParent}
                                idProduct={idProduct}
                                onRequestSerproCnpj={(
                                  question,
                                  data,
                                  filteredQuestionnaire,
                                  setFilteredQuestionnaire,
                                  setFieldValue
                                ) => handleRequestSerproCnpj(question,
                                  data,
                                  filteredQuestionnaire,
                                  setFilteredQuestionnaire,
                                  setFieldValue
                                )}
                                isSelectMarketsScreen
                                onBlur={(e) => {
                                  if (e.idQuestion == 760) {
                                    getObligorCodingPercentage(e, index, formikProps.values)
                                    formikProps?.setFieldValue(`${e.key}_old`, e.answer)
                                  }
                                }}
                              />
                            )
                          }
                        })}
                        <TotalValueContainer>
                          <TotalContainer>
                            <HrTotal></HrTotal>
                            {formikProps.values.obligorCodingTotal != null && <Text style={{ whiteSpace: "nowrap" }}>{parseFloat(formikProps.values.obligorCodingTotal).toFixed(5) || '0.00000'}%</Text>}
                          </TotalContainer>
                        </TotalValueContainer>
                      </div>

                      <div style={{ marginLeft: 15 }}>
                        <Row style={{ marginTop: 50, marginBottom: 10 }}>
                          <Title>TAXES</Title>
                        </Row>
                        <FormSection
                          sectionName="TAX_RATES"
                          values={formikProps.values}
                          disableAll={lockAndSaveCoverages || !canGroup}
                          questionnaire={questionnaire}
                          setFieldValue={formikProps.setFieldValue}
                          formikRef={formik}
                          isInverse={true}
                          idOperation={props.match?.params?.idOperation}
                          idProduct={idProduct}
                          ignoreModality
                          onQuestionChange={(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
                            loading.start();
                            handleTaxes(answer, null, true)
                          }}
                        />
                        {insurerGroup.map((questions, index) => (
                          <FormSection
                            sectionName="INSURER_TAXES"
                            values={formikProps.values}
                            errors={formikProps.errors}
                            disableAll={isBound || lockAndSaveCoverages}
                            setFieldValue={formikProps.setFieldValue}
                            setFieldError={formikProps.setFieldError}
                            sectionIndex={index}
                            idProduct={idProduct}
                            questionnaire={questions}
                            formikRef={formik}
                            ignoreModality
                            replaceQuery={isGrouped ? [
                              { searchQueryId: 'getFacilities', values: [{ id: -1, value: 'All' }] },
                              { searchQueryId: 'getInsurers', values: [{ id: -1, value: 'All' }] }
                            ] : null}
                            onQuestionChange={(
                              question,
                              value,
                              filteredQuestionnaire,
                              setFilteredQuestionnaire,
                              setFieldValue
                            ) => handleQuestionChange(
                              question,
                              value,
                              filteredQuestionnaire,
                              setFilteredQuestionnaire,
                              setFieldValue,
                              questionnaire,
                            )}
                            extraButtons={() => {
                              const result = validateRenderButtons(questions);
                              if (!result) {
                                return renderAddAndRemoveButtons(
                                  insurerGroup,
                                  index,
                                  questions,
                                  setInsurerGroup,
                                  "$ANSWERS_INSURER_TAXES_0",
                                  formikProps.values
                                )
                              } else if (insurerGroup.length - 1 == index) {
                                return renderAddButtons(
                                  insurerGroup,
                                  index,
                                  questions,
                                  setInsurerGroup,
                                  "$ANSWERS_INSURER_TAXES_0",
                                  formikProps.values
                                )
                              }
                            }}
                            idOperation={props.match?.params?.idOperation}
                            idOperationParent={
                              props.match?.params?.idOperationParent
                            }
                          />
                        ))}

                        <FormSection
                          sectionName="LOCK_AND_SAVE_COVERAGES_TAXES"
                          values={formikProps.values}
                          disableAll={isBound}
                          questionnaire={questionnaire}
                          setFieldValue={formikProps.setFieldValue}
                          formikRef={formik}
                          isInverse={true}
                          idOperation={props.match?.params?.idOperation}
                          idProduct={idProduct}
                          ignoreModality
                          onQuestionChange={(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
                            setLockAndSaveCoverages(answer?.idAnswerOption === 7095);

                            if (answer?.idAnswerOption === 7095) {
                              buildValidation(null, true).validate(formikProps.values, { abortEarly: false }, true).then(() => {
                                setLoadingTimeout(true)
                                setTimeout(() => {
                                  setLoadingTimeout(false)
                                  handleTaxesAndCoverages(answer);
                                }, 1000)
                              }).catch((e) => {
                                mc.error('Please, fill in all required fields.')
                                setLockAndSaveCoverages(false);
                                formikProps?.setFieldValue(question.key, "No")
                              })
                            } else {
                              setLockAndSaveCoverages(false);
                            }
                          }}
                        />
                      </div>
                    </> : null}
                  </>
                </Scrollbox>

                <ButtonContainer>
                  <Button style={{ padding: "0.75rem 0" }} forth onClick={() => { history.goBack() }}>&lt; Back</Button>
                  <HasPermission permission={!isBound}>
                    <RenderButtons idOperation={props.match?.params?.idOperation}>
                      <ButtonContent>
                        <div style={{ marginTop: "5px" }}>
                          <LostCancelButton idOperation={props.match?.params?.idOperation} />
                        </div>
                        {!endorsmentType && renderFlowClient(formikProps)}

                        {endorsmentType &&
                          <>
                            {(endorsmentType === 'market-changes' || endorsmentType === 'declaration') &&
                              <Button
                                third
                                style={{ marginLeft: "10px", marginTop: "5px" }}
                                onClick={(e) => handleCreateMarketChangeQuotation()}>
                                UPDATE NBI
                              </Button>}
                            {isExported ? <>
                              {
                                isImported ?
                                  (
                                    <>
                                      <Button
                                        third
                                        style={{ marginLeft: "10px", marginTop: "5px" }}
                                        name="viewSchedule"
                                        id="viewSchedule"
                                        onClick={(e) => {
                                          let idOperationRediret = isUpdatedSchedule ? idOperationRedirect : props.match.params.idOperation;

                                          if (isUpdatedSchedule) {
                                            history.push(`/broking/schedule-exibition-updated-schedule/${idOperationRediret}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null });
                                          } else {
                                            history.push(`/broking/schedule-exibition/${idOperationRediret}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null });
                                          }
                                        }}>
                                        VIEW SCHEDULE
                                      </Button>
                                      {
                                        endorsmentType === "declaration"
                                          ? (
                                            <HasPermission
                                              permission={props.permissions.GENERATE_MRC}
                                            >
                                              <Button
                                                primary
                                                style={{ marginLeft: "10px", marginTop: "5px" }}
                                                onClick={() => handleGenerateMrc()}>
                                                GENERATE MRC
                                              </Button>
                                            </HasPermission>

                                          ) : endorsementButton(formikProps)
                                      }
                                    </>
                                  ) : (
                                    <HasPermission
                                      permission={props.permissions.IMPORT_SCHEDULE}
                                    >
                                      <PlaceHolder style={{ marginTop: "5px" }} disabled={!lockAndSaveCoverages} primary htmlFor="fileInput">IMPORT</PlaceHolder>
                                      <TagInput id="fileInput" name="fileInput" disabled={!lockAndSaveCoverages} type="file" multiple={false} onChange={(event) => { handleUpload(event, formikProps); formikProps?.setFieldValue('fileInput', '') }} />
                                    </HasPermission>

                                  )
                              }
                            </> :
                              (
                                <HasPermission
                                  permission={props.permissions.EXPORT_SCHEDULE}
                                >
                                  <Button primary onClick={() => { handleExport() }} disabled={!formikProps.values.lock} style={{ marginLeft: "10px", textAlign: "center", marginTop: "5px" }}>
                                    EXPORT
                                  </Button>
                                </HasPermission>)
                            }
                          </>
                        }
                      </ButtonContent>
                    </RenderButtons>
                  </HasPermission>

                  {isUpdatedSchedule && (
                    <>
                      <PlaceHolder style={{ marginTop: "5px" }} primary htmlFor="fileInput">UPLOAD SCHEDULE</PlaceHolder>
                      <TagInput id="fileInput" name="fileInput" type="file" multiple={false} onChange={(event) => { handleUpload(event, formikProps); formikProps?.setFieldValue('fileInput', '') }} />
                    </>
                  )}
                </ButtonContainer>
              </Form>
            )}
          </Formik>
          {insurerContacts &&
            <ModalContacts
              show={modalUnderwriter}
              onModalClose={() => {
                setSelectedUnderwriters([])
                setModalUnderwriter(false)
              }}
              onConfirm={() => handleUpdateNBIManually(insurerContacts, selectedUnderwriters)}
            >
              <Row style={{ marginBottom: "10px" }}>
                <Title>SELECT UNDERWRITERS TO NOTIFY THEM ABOUT THE CHANGES</Title>
              </Row>
              <Row>
                <Col md={12} sm={12}>
                  <Title>TO</Title>
                  <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                    <Title>
                      {insurerContacts.insurerFirstName}
                    </Title>
                  </Row>
                  <Scrollbox>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableHeader>
                          </TableHeader>
                          <TableHeader>
                            <GridColumnTitle style={{ textTransform: 'uppercase' }}>
                              Legal Entity
                            </GridColumnTitle>
                          </TableHeader>
                          <TableHeader>
                            <GridColumnTitle style={{ textTransform: 'uppercase' }}>
                              Name
                            </GridColumnTitle>
                          </TableHeader>
                          <TableHeader>
                            <GridColumnTitle style={{ textTransform: 'uppercase' }}>
                              Department
                            </GridColumnTitle>
                          </TableHeader>
                          <TableHeader style={{ textAlign: 'center' }}>
                            <GridColumnTitle style={{ textTransform: 'uppercase' }}>
                              E-mail
                            </GridColumnTitle>
                          </TableHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {insurerContacts.contacts.length ? insurerContacts.contacts.map((contact) => (
                          <TableRow key={contact.idContact}>
                            <TableCollum>
                              <label>
                                <CheckBox
                                  onChange={() => handleSelectUnderwriter(contact)}
                                  checked={selectedUnderwriters.find((item) => item.idContact === contact.idContact) ? true : false}
                                />
                              </label>
                            </TableCollum>
                            <TableCollum>
                              <InlineLabel>Legal Entity</InlineLabel>
                              <LabelEdit>
                                {contact.legalEntity}
                              </LabelEdit>
                            </TableCollum>
                            <TableCollum >
                              <InlineLabel>Name</InlineLabel>
                              <LabelEdit>{contact.nameContact}</LabelEdit>
                            </TableCollum>
                            <TableCollum>
                              <InlineLabel>Department</InlineLabel>
                              <LabelEdit>{contact.personContactDepartment}</LabelEdit>
                            </TableCollum>
                            <TableCollum >
                              <InlineLabel>E-mail</InlineLabel>
                              <LabelEdit>{contact.email}</LabelEdit>
                            </TableCollum>
                          </TableRow>
                        )) : (
                          <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                            <Label>
                              No results found.
                            </Label>
                          </Row>
                        )
                        }
                      </TableBody>
                    </Table>
                  </Scrollbox>
                </Col>
              </Row>
            </ModalContacts>
          }
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </>
      </ContentCard>
    </Layout >
  )
}
